import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import HowToPlayModal from "../how-to-play-modal/how-to-play-modal";
import { useStyles } from "./style";
import useQuizCodeServerValidation from "./useQuizCodeServerValidation";
import classNames from "classnames";
import { cleanInput, isCodeInputValid } from "./codeInputHelpers";
import {RefButton} from "../like-button-ref/like-button-ref";
import { Translate } from "../../locales/locales-utils";
import { GAME_SITE_URL } from 'gatsby-env-variables-fork';

const JoinQuizForm = () => {
  const [code, setCode] = useState("");
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isCodeValidationError, setIsCodeValidationError] = useState(false);
  const [isOpenHowToPlayModal, setIsOpenHowToPlayModal] = useState(false);

  const { isFetching, validateCode } = useQuizCodeServerValidation();

  const classes = useStyles();

  const setErrorStateTimeout = () => {
    setTimeout(() => {
      setIsCodeValidationError(false);
    }, 4000);
  };

  const onValidateClick = async (e: Event) => {
    e.preventDefault();

    if (!code) {
      setIsCodeValidationError(true);
      setErrorStateTimeout();
      return;
    }
    const validationResult = await validateCode(code);

    if (!validationResult) {
      toast.error(Translate("Index.JoinToQuizForm.QuizValidationError"));
      return;
    }

    setIsCodeValidationError(!validationResult.IsValid);

    if (!validationResult.IsValid) {
      setErrorStateTimeout();
    }

    let quizCode;

    if (code.length < 8) {
      quizCode = '0'.repeat(8 - code.length) + code;
    } else {
      quizCode = code;
    }

    if (validationResult.IsValid && typeof window !== "undefined") {
      setIsRedirecting(true);
      window.location.href = `${GAME_SITE_URL}/p/${quizCode}`;
    }
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (isCodeInputValid(input)) {
      setCode(cleanInput(input));
    }
  };

  const openHowToPlayModal = () => {
    setIsOpenHowToPlayModal(true);
  };

  const closeHowToPlayModal = () => {
    setIsOpenHowToPlayModal(false);
  };

  return (
    <>
      <div className={classes.joinQuizCode}>
        <div className={'container ' + classes.joinQuizCodeContainer}>
          <div className={classes.joinQuizCodeTitle}>
            {Translate("Index.JoinToQuizForm.Title")}
          </div>
          <div className={classes.joinQuizCodeFormContainer}>
            <form className={classes.joinQuizCodeForm} noValidate>
              <input
                  type="tel"
                  className={classNames(classes.joinQuizCodeInput, {
                    [classes.joinQuizCodeInputError]: isCodeValidationError,
                  })}
                  placeholder="12345678"
                  value={code}
                  maxLength={100}
                  onChange={onInputChange}
                  required
              />
              <RefButton
                  tag="button"
                  text={Translate("Index.JoinToQuizForm.Play")}
                  size="lg"
                  variant="primary"
                  onClick={onValidateClick}
                  classNames={classes.joinQuizCodeButton}
                  disabled={isFetching || isRedirecting}
                  spin={isFetching || isRedirecting}
                  type="submit"
              />
              {isCodeValidationError && (
                <div className={classes.joinQuizCodeValidationTooltip}>
                  {Translate("Index.JoinToQuizForm.InvalidQuizCode")}
                </div>
              )}
            </form>
            <div onClick={openHowToPlayModal} className={classes.joinQuizCodeHotToPlay}>
              {Translate("Index.JoinToQuizForm.HowToPlay")}
            </div>
          </div>
        </div>
      </div>
      <HowToPlayModal isOpen={isOpenHowToPlayModal} closeHandle={closeHowToPlayModal}/>
    </>
  );
};

export default JoinQuizForm;
